import axios from "@axios";
import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchIssues(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/stock_issues", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProductsBySupplierId(ctx, { supplierId }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/suppliers/${supplierId}/products`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchIssue(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/stock_issues/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addIssue(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/stock_issues", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateIssue(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/stock_issues", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteIssue(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/stock_issues", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
